/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedinteraccountingemail13Inputs */

const en__field_inheritedinteraccountingemail13 = /** @type {(inputs: _Field_Inheritedinteraccountingemail13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`internal accounting e-mail 1 (inherited)`)
};

const de__field_inheritedinteraccountingemail13 = /** @type {(inputs: _Field_Inheritedinteraccountingemail13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne Accounting E-Mail 1 (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "internal accounting e-mail 1 (inherited)" |
*
* @param {_Field_Inheritedinteraccountingemail13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedinteraccountingemail13 = /** @type {((inputs?: _Field_Inheritedinteraccountingemail13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedinteraccountingemail13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedinteraccountingemail13(inputs)
	return de__field_inheritedinteraccountingemail13(inputs)
});
export { _field_inheritedinteraccountingemail13 as "_field_inheritedInterAccountingEmail1" }